<section class="datenschutz-section">
  <div class="container">
    <div class="impressum-header">
      <h1 class="headline-text">Kontakt / Impressum</h1>
      <button class="back-button" (click)="handleBackButtonClick()">
        <app-icon
          iconName="redo"
          iconColor="#0d1424"
          iconSize="2.4rem"
        ></app-icon>
        <p>zurück</p>
      </button>
    </div>

    <h2 class="header-text">Angaben gemäß § 5 TMG:</h2>
    <p class="line">Helix GPO UG (haftungsbeschränkt) & Co. KG</p>
    <p class="line">Erftstraße 50</p>
    <p class="line">41460 Neuss</p>
    <p class="line bottom">Deutschland</p>

    <h2 class="header-text">
      Vertreten durch die persönlich haftende Gesellschafterin:
    </h2>
    <p class="line">Helix GPM UG (haftungsbeschränkt)</p>
    <p class="line">Erftstraße 50</p>
    <p class="line">41460 Neuss</p>
    <p class="line bottom">Deutschland</p>

    <h2 class="header-text">Vertretungsberechtigte Geschäftsführer:</h2>
    <p class="line name">- Henry Heller</p>
    <p class="line">Erftstraße 50</p>
    <p class="line">41460 Neuss</p>
    <p class="line">Email: heller-henry&#64;web.de</p>
    <p class="line name-bottom">Telefon: +49 173 2471408</p>

    <p class="line name">- Felix Breuer</p>
    <p class="line">Weberstraße 39</p>
    <p class="line">41464 Neuss</p>
    <p class="line">Email: felixbreuer62&#64;gmail.com</p>
    <p class="line bottom">Telefon: +49 1511 4924348</p>

    <h2 class="header-text">Kontaktaufnahme:</h2>
    <p class="line bottom">Email: helix.gpo&#64;gmail.com</p>

    <h2 class="header-text">Registereintrag:</h2>
    <p class="line">
      Helix GPO UG (haftungsbeschränkt) & Co. KG: Amtsgericht Neuss - HRA 8250
    </p>
    <p class="line bottom">
      Helix GPM UG (haftungsbeschränkt): Amtsgericht Neuss - HRB 23470
    </p>

    <h2 class="header-text">Steuernummern:</h2>
    <p class="line">
      Helix GPO UG (haftungsbeschränkt) & Co. KG: 122/5821/1859
    </p>
    <p class="line bottom-bot">
      Helix GPM UG (haftungsbeschränkt): 122/5734/0040
    </p>

    <h1 class="headline-text">Haftungsausschluss – Disclaimer</h1>
    <h2 class="header-text">Haftung für Inhalte</h2>
    <p class="line bottom">
      Alle Inhalte unseres Internetauftritts wurden mit größter Sorgfalt und
      nach bestem Gewissen erstellt. Für die Richtigkeit, Vollständigkeit und
      Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als
      Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
      Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG
      sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
      gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
      forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen
      zur Entfernung oder Sperrung der Nutzung von Informationen nach den
      allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche
      Haftung ist jedoch erst ab dem Zeitpunkt der Kenntniserlangung einer
      konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
      Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
    </p>

    <h2 class="header-text">Haftungsbeschränkung für externe Links</h2>
    <p class="line bottom">
      Unser Angebot enthält Links zu externen Websites Dritter, auf deren
      Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
      Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
      Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
      verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung
      auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
      Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche
      Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
      einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
      Rechtsverletzungen werden wir derartige Links umgehend entfernen.
    </p>

    <h2 class="header-text">Urheberrecht</h2>
    <p class="line">
      Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
      Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
      Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
      des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
      Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
      privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
      dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
      Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
      gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
      aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
      Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend
      entfernen.
    </p>
  </div>
</section>
